import { ChatSocketMessage } from '@/types/supportChat';

let ws: WebSocket | null = null;
const listeners = new Set<(msg: ChatSocketMessage) => void>();
const errorListeners = new Set<(err: unknown) => void>();
const sendQueue: unknown[] = [];

export const initSocket = (url: string, token?: string, chatSessionId: string = '') => {
  if (ws) return;
  ws = new WebSocket(url);

  ws.onopen = () => {
    if (token) {
      ws?.send(
        JSON.stringify({
          type: 'auth',
          token,
          chat_session_id: chatSessionId,
        }),
      );
    }
  };

  ws.onmessage = (ev) => {
    try {
      const data = JSON.parse(ev.data);
      listeners.forEach((l) => l(data));
    } catch (err) {
      errorListeners.forEach((cb) => cb({ type: 'parse_error', error: err }));
    }
  };

  ws.onclose = () => {
    ws = null;
  };

  ws.onerror = () => {
    errorListeners.forEach((cb) => cb({ type: 'error', event }));
  };
};

export const subscribeSocket = (cb: (msg: ChatSocketMessage) => void) => {
  listeners.add(cb);
  return () => listeners.delete(cb);
};
export const subscribeSocketError = (cb: (err: unknown) => void) => {
  errorListeners.add(cb);
  return () => errorListeners.delete(cb);
};

export const sendSocket = (payload: {
  type: string;
  text?: string;
  bitrix_message_id?: string;
}) => {
  if (ws && ws.readyState === WebSocket.OPEN) {
    try {
      ws.send(JSON.stringify(payload));
    } catch (err) {
      errorListeners.forEach((cb) => cb({ type: 'send_error', error: err, payload }));
    }
  } else {
    sendQueue.push(payload);
    errorListeners.forEach((cb) =>
      cb({ type: 'not_connected', message: 'WebSocket not connected', payload }),
    );
  }
};

export const isSocketConnected = () => ws && ws.readyState === WebSocket.OPEN;

export const closeSocket = (): Promise<void> => {
  return new Promise((resolve) => {
    try {
      if (!ws) {
        sendQueue.length = 0;
        return resolve();
      }

      // Подпишемся на onclose чтобы дождаться закрытия
      const socket = ws;
      const prevOnClose = socket.onclose;
      socket.onclose = (ev) => {
        try {
          // вызвать предыдущий onclose с корректным this (socket)
          if (typeof prevOnClose === 'function') {
            prevOnClose.call(socket, ev as CloseEvent);
          }
        } catch {
          // Preserve cleanup even if a previous close handler fails.
        }
        try {
          sendQueue.length = 0;
        } catch {
          // Cleanup is best-effort.
        }
        // очистим глобальную ссылку и резолвнем
        if (ws === socket) ws = null;
        resolve();
      };

      try {
        socket.close();
      } catch {
        // если close выбросил - очистим и резолвнем
        listeners.clear();
        errorListeners.clear();
        sendQueue.length = 0;
        if (ws === socket) ws = null;
        resolve();
      }

      // fallback: если onclose не придёт за 2s — принудительно завершить
      setTimeout(() => {
        if (ws === socket) {
          sendQueue.length = 0;
          ws = null;
        }
        resolve();
      }, 2000);
    } catch {
      // гарантируем резолв
      try {
        sendQueue.length = 0;
        ws = null;
      } catch {
        // Cleanup is best-effort.
      }
      resolve();
    }
  });
};
